export enum WOH_CHOICE {
  DACHGESCHOSS = 'dachgeschoss',
  PHOTOVOLTAIK_MITVERSICHERUNG = 'photovoltaikMitversicherung',
  PHOTOVOLTAIK_MONTAGE = 'photovoltaikMontage',
  ABLEITUNGSROHRE = 'ableitungsrohre',
  GEBAEUDETYP = 'gebaeudetyp',
}

export enum WOH_META {
  DACHGESCHOSS = 'requiresArea',
  DACHGESCHOSS_FLAT_ROOF = 'flatRoof',
  DACHGESCHOSS_ATTIC = 'attic',
  DACHGESCHOSS_ATTIC_EXTENDED = 'atticExtended',

  REQUIRES_UNITS = 'requiresUnits',

  ABLEITUNGSROHRE_NICHT_WICHTIG = 'notImportant',
}
